<app-page>
    <app-device-header [deviceId]="deviceId"></app-device-header>
    <app-orders [ordersModel]="odersModel"></app-orders>
</app-page>
